export default __webpack_public_path__ + "static/media/register.f826f0fe.svg";